import { enumColorPickAdvMode, enumFillMode } from "../constants";
import { TPPostColorPicker } from "./TPPostColorPicker";

export function TPostColorPicker(
  wsMgr,
  parent,
  x,
  y,
  baseCmd,
  enableNoFill,
  enableCustom,
  startColor,
  aCmd
) {
  var startColor2 = null;
  var fillMode = enumFillMode.solidFill;
  return TPPostColorPicker(
    wsMgr,
    parent,
    x,
    y,
    baseCmd,
    enableNoFill,
    enableCustom,
    startColor,
    startColor2,
    fillMode,
    enumColorPickAdvMode.disabled,
    null,
    null,
    aCmd
  );
}
